export default "__VITE_ASSET__l6K1o8VB__"